<div class="language-switcher">

  <form class="form-group">

    <select
      title="{{ 'HOME.SELECT-LANGUAGE' | translate }}"
      class="form-control custom-select language-select"
      name="languageSwitcher"
      [(ngModel)]="selectedLanguage"
      (change)="updateLanguage()">
      
      <ng-container *ngFor="let lang of languages">
        <ng-container *ngIf="consolidator === 'USAT'; else otherLanguage">
          <ng-container *ngIf="lang === 'fr' || lang === 'nl'">
            <option value="{{ lang }}">{{languageNames[lang] | uppercase}}</option>
          </ng-container>
        </ng-container>
        <ng-template #otherLanguage>
          <option value="{{ lang }}">{{languageNames[lang] | uppercase}}</option>
        </ng-template>
      </ng-container>

    </select>

  </form>

</div>